import React, { useEffect, useState } from "react";
import { Button, DatePicker, Form, Pagination, notification, Table } from "antd";
import { LeftCircleOutlined } from "@ant-design/icons";
import { checkRepayment, formatNumberWithDots, getStatusDiv } from "../../helpers/utils";
import locale from "antd/es/date-picker/locale/vi_VN";
import $axios from "../../services/axios";
import DetailTransaction from "../Common/DetailTransaction";
import moment from "moment";
import dayjs from "dayjs";

const DesktopHistory = ({ airports, onChangeStep, setLoading, airlines, fareclass }) => {
    const [form] = Form.useForm();
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [detailTicket, setDetailTicket] = useState(null);
    const [listHistory, setListHistory] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rangePresets = [
        { label: "7 ngày qua", value: [dayjs().add(-7, "d"), dayjs()] },
        { label: "14 ngày qua", value: [dayjs().add(-14, "d"), dayjs()] },
        { label: "30 ngày qua", value: [dayjs().add(-30, "d"), dayjs()] },
        { label: "90 ngày qua", value: [dayjs().add(-90, "d"), dayjs()] },
    ];

    useEffect(() => { getListHistory(currentPage, rangePresets[0].value); }, []);

    const getListHistory = async (page, dateRange) => {
        const startTime = dayjs(dateRange[0]).format("DD/MM/YYYY");
        const endTime = dayjs(dateRange[1]).format("DD/MM/YYYY");
        setLoading(true);
        try {
            const res = await $axios.$get(`/order-flight/findByAllUser?startdate=${startTime}&enddate=${endTime}&page=${page}&pageSize=10`);
            setListHistory(res.data.data.data);
            setTotal(res.data.data.data.totalRecordCount);
        } catch (error) { notification.error({ message: "Thất bại", description: "Đã có lỗi xảy ra!" }); }
        finally { setLoading(false); }
    };

    const onFinish = async (values) => { await getListHistory(currentPage, values.dateRange); };

    const rePayment = (item) => {
        if (window.webkit?.messageHandlers?.NativeJavascriptInterface) {
            window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({ orderCode: item.ordercode });
        } else if (window.webkit?.messageHandlers?.appInterface) {
            window.webkit.messageHandlers.appInterface.postMessage(JSON.stringify({ orderCode: item.ordercode }));
        } else if (window.appInterface) {
            window.appInterface.postMessage(JSON.stringify({ orderCode: item.ordercode }));
        }
    };

    const columns = [
        {
            title: 'Mã đơn hàng / Thời gian',
            dataIndex: 'ordercode',
            key: 'ordercode',
            render: (text, record) => (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontWeight: 700, color: '#1d4ed8' }}>{text}</span>
                    <span style={{ fontSize: '12px', color: '#94a3b8' }}>{moment(record.createdat).format("HH:mm DD/MM/YYYY")}</span>
                </div>
            ),
        },
        {
            title: 'Chuyến bay',
            key: 'flight',
            render: (_, record) => {
                if (!record?.orderplanebookings?.length) return null;
                const o = record.orderplanebookings[0];
                const airLineInfo = airlines?.find(a => a.code === o.airline);
                const fromName = airports?.find(a => a.code === o.fromairport)?.name;
                const toName = airports?.find(a => a.code === o.toairport)?.name;
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {airLineInfo && <img src={`${process.env.REACT_APP_BASE_URL}/${airLineInfo.iconurl}`} style={{ height: '16px', objectFit: 'contain' }} alt="" />}
                            <span style={{ fontWeight: 600, color: '#1e293b' }}>{o.airline}</span>
                        </div>
                        <div style={{ fontSize: '13px', fontWeight: 500, color: '#475569' }}>
                            {fromName} ({o.fromairport}) ⟶ {toName} ({o.toairport})
                        </div>
                        <div style={{ fontSize: '12px', color: '#94a3b8' }}>
                            {record?.orderplanes?.[0]?.recovery === 1 ? "Khứ hồi" : "Một chiều"}
                        </div>
                    </div>
                );
            }
        },
        {
            title: 'Trạng thái', key: 'status', align: 'center',
            render: (_, record) => (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {getStatusDiv(record?.paymentstatus === "Success" ? record?.orderplanebookings?.[0]?.status || record?.paymentstatus : record?.paymentstatus, checkRepayment(record?.orderplanebookings?.[0]?.expirationdate))}
                    {record?.orderplanebookings?.length > 0 && checkRepayment(record?.orderplanebookings[0]?.expirationdate) && record?.paymentstatus === "PayLater" && (
                        <div onClick={() => rePayment(record)} style={{ marginTop: '8px', color: 'white', background: '#ef4444', cursor: 'pointer', borderRadius: '20px', padding: '4px 14px', fontSize: '12px', fontWeight: 600, transition: 'all 0.2s' }}>
                            Thanh toán lại
                        </div>
                    )}
                </div>
            )
        },
        {
            title: 'Hành động', key: 'action', align: 'right',
            render: (_, record) => (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
                    <div style={{ fontWeight: 800, color: '#f97316', fontSize: '17px' }}>{formatNumberWithDots(record.amount)} <span style={{ fontSize: '13px' }}>đ</span></div>
                    {record?.orderplanetickets?.length > 0 && (
                        <Button type="link" onClick={() => { setDetailTicket(record); setDrawerVisible(true); }} style={{ padding: 0, height: 'auto', fontSize: '13px', fontWeight: 600 }}>Xem chi tiết</Button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="desktop-history-container" style={{ minHeight: '100vh', background: '#f0f4f8', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: '48px', fontFamily: "'Inter', sans-serif" }}>

            {/* Header Banner */}
            <div style={{ width: '100%', position: 'relative', background: 'linear-gradient(135deg, #0f172a, #1e3a5f)', height: '200px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column', justifyContent: 'center', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: '20px', left: '24px', zIndex: 10 }}>
                    <Button type="text" onClick={() => onChangeStep(1)} icon={<LeftCircleOutlined style={{ fontSize: '28px', color: 'white' }} />} />
                </div>
                <div style={{ position: 'relative', zIndex: 10, maxWidth: '1200px', margin: '0 auto', width: '100%', padding: '0 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h1 style={{ fontSize: '32px', fontWeight: 800, color: 'white', marginBottom: '4px' }}>Lịch Sử Đặt Vé</h1>
                        <p style={{ color: '#93c5fd', fontSize: '16px' }}>Quản lý và theo dõi các chuyến bay của bạn</p>
                    </div>
                </div>
            </div>

            {/* Filter & Content */}
            <div style={{ width: '100%', maxWidth: '1200px', margin: '0 auto', padding: '0 32px', marginTop: '-28px', position: 'relative', zIndex: 20 }}>
                <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 4px 15px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0', padding: '20px 24px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Form form={form} onFinish={onFinish} initialValues={{ dateRange: rangePresets[0].value }} style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: 0 }}>
                        <div style={{ fontWeight: 600, color: '#475569', fontSize: '14px' }}>Lọc theo thời gian:</div>
                        <Form.Item name="dateRange" rules={[{ required: true, message: "Chọn thời gian!" }]} style={{ margin: 0, minWidth: '280px' }}>
                            <DatePicker.RangePicker presets={rangePresets} format="DD/MM/YYYY" locale={locale} size="large" style={{ width: '100%', borderRadius: '10px' }} />
                        </Form.Item>
                        <Form.Item style={{ margin: 0 }}>
                            <Button type="primary" htmlType="submit" size="large" style={{ background: '#2563eb', border: 'none', fontWeight: 700, borderRadius: '10px', padding: '0 24px' }}>Tìm kiếm</Button>
                        </Form.Item>
                    </Form>
                    <div style={{ textAlign: 'right', borderLeft: '1px solid #e2e8f0', paddingLeft: '20px' }}>
                        <span style={{ color: '#94a3b8', fontWeight: 500, display: 'block', fontSize: '12px' }}>Tổng đài hỗ trợ 24/7</span>
                        <a href="tel:1900255585" style={{ fontWeight: 700, color: '#f97316', fontSize: '22px', letterSpacing: '1px' }}>1900 255 585</a>
                    </div>
                </div>

                {/* Table */}
                <div style={{ background: 'white', borderRadius: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                    <Table
                        columns={columns} dataSource={listHistory} rowKey="id" pagination={false}
                        locale={{ emptyText: "Không tìm thấy lịch sử đặt vé nào." }}
                    />
                </div>

                {total > 0 && (
                    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                        <Pagination current={currentPage} total={total} pageSize={10} onChange={(page) => { setCurrentPage(page); getListHistory(page, form.getFieldValue('dateRange')); }} showSizeChanger={false} />
                    </div>
                )}
            </div>

            {drawerVisible && detailTicket && (
                <DetailTransaction visible={drawerVisible} onClose={() => setDrawerVisible(false)} ticketDetails={detailTicket} airports={airports} fareclass={fareclass} airlines={airlines} />
            )}
        </div>
    );
};

export default DesktopHistory;
